// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/conversion/v1/conversion_api.proto (package gdx.gateway.web.conversion.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetFacebookTrackingParamsRequest, GetFacebookTrackingParamsResponse, ListUndeliveredConversionsRequest, ListUndeliveredConversionsResponse, UpdateLastDeliveredTimeRequest, UpdateLastDeliveredTimeResponse } from "./conversion_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Contains methods which are related to conversions.
 *
 * @generated from service gdx.gateway.web.conversion.v1.ConversionAPI
 */
export const ConversionAPI = {
  typeName: "gdx.gateway.web.conversion.v1.ConversionAPI",
  methods: {
    /**
     * Returns list of undelivered conversions.
     *
     * @generated from rpc gdx.gateway.web.conversion.v1.ConversionAPI.ListUndeliveredConversions
     */
    listUndeliveredConversions: {
      name: "ListUndeliveredConversions",
      I: ListUndeliveredConversionsRequest,
      O: ListUndeliveredConversionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Update last delivered time.
     *
     * @generated from rpc gdx.gateway.web.conversion.v1.ConversionAPI.UpdateLastDeliveredTime
     */
    updateLastDeliveredTime: {
      name: "UpdateLastDeliveredTime",
      I: UpdateLastDeliveredTimeRequest,
      O: UpdateLastDeliveredTimeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns fb tracking params for auth users. In case of non auth user returns PixelConfig only.
     *
     * @generated from rpc gdx.gateway.web.conversion.v1.ConversionAPI.GetFacebookTrackingParams
     */
    getFacebookTrackingParams: {
      name: "GetFacebookTrackingParams",
      I: GetFacebookTrackingParamsRequest,
      O: GetFacebookTrackingParamsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

